import { useEffect, useState } from 'react';
import CountryService from '../Shared/Services/CountryService';
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';

export const ViewCountry = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const [country, setCountry] = useState("");

    useEffect(() => {
        getCountryById();
    }, []);

    const getCountryById = async () => {
        try {
            CountryService.getById(id).then((res: any) => {
                setCountry(res.data.name);
            })
        } catch (error) {
            console.error(error);
        }
    };

    return (
        <>
            <div className="card card-default">
                <div className="card-header">
                    <h4>Country Details</h4>
                </div>
                <div className="card-body">
                    <div className="form-group row">
                        <label className="col-sm-3 control-label"><b>Name</b></label>
                        <div className="col-sm-9">
                            { country }
                        </div>
                    </div>
                    <br />
                    <div className="form-group row">
                        <div className=" col-sm-offset-3">
                            <a className="btn btn-secondary" onClick={() => navigate('/country')}>Back</a>
                            <button className="btn btn-primary ms-1" onClick={() => navigate(`/editcountry/${id}`)}>Edit</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}